import { observer } from 'mobx-react-lite';

import { mergeRefs } from 'src/shared/utils/merge-refs';

import type { ChartRig, RigsGroup, TemporaryChartRig } from '../../../presets/drilling-rigs-chart/entities';
import { useMovableElement } from '../../../shared/use-movable-element';
import type { Viewport } from '../../../shared/viewport/viewport';
import { useDragging } from '../../sorting/hooks/use-dragging';

import styles from './data-items.module.scss';

interface Props {
  item: ChartRig | TemporaryChartRig | RigsGroup;
  verticalViewport: Viewport;
}

export const EditingRigRow = observer(function EditingRigRow({ item, verticalViewport }: Props) {
  const { ref: draggingRef } = useDragging({
    id: item.getKey('dragging-row'),
    item,
  });

  const ref = useMovableElement({
    item,
    verticalViewport,
  });

  return <div ref={mergeRefs(ref, draggingRef)} className={styles.rigRow} />;
});
